define.alias("shared/utils/hash-code", "calendar/utils/hash-code");